import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-success',
    templateUrl: './toast-success.component.pug',
    styleUrls: ['./toast-success.component.less'],
})
export class ToastSuccessComponent {
    @Input() count: number = null;

    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }
}
